export default __webpack_public_path__ + "static/media/fxPickupGolden.e0a83ea2.mp3";